import React, { createContext, useContext, useEffect, useState } from 'react';

import { Filters } from 'context/FilterProvider/types/Filters';
import { defaultFilters } from 'context/FilterProvider/utils/defaultFilters';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import { toFilters } from 'utils/searchParamsConverter';

const FilterContext = createContext<{
  filters: Filters;
  setFilters: (filters: Filters) => void;
}>({
  filters: defaultFilters,
  setFilters: () => {},
});

export const useFilters = () => useContext(FilterContext);

type FilterProviderProps = {
  children: React.ReactNode;
};

export const FilterProvider = ({ children }: FilterProviderProps) => {
  const { searchParams, updateFiltersSearchParams } = useSearchParamsProvider();
  const [filters, setFilters] = useState<Filters>(defaultFilters);

  useEffect(() => {
    const filtersFromSearchParams = toFilters(searchParams);
    setFilters(filtersFromSearchParams);
  }, [searchParams]);

  const updateFilters = (newFilters: Filters) => {
    setFilters(newFilters);
    updateFiltersSearchParams(newFilters);
  };

  return (
    <FilterContext.Provider value={{ filters, setFilters: updateFilters }}>
      {children}
    </FilterContext.Provider>
  );
};
